import axios from "axios";
import store from "../../../store";
import apiTokenRefresh from "../../../services/refreshToken";

const BASE_URL = `${import.meta.env.VITE_API_ENDPOINT}`;

const axiosWebsitePrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor
axiosWebsitePrivate.interceptors.request.use(
  (config) => {
    const { accessToken } = store.getState().auth;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosWebsitePrivate.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 403 && !prevRequest?.sent) {
      prevRequest.sent = true;
      const { refreshToken } = store.getState().auth;
      const newAccessToken = await apiTokenRefresh(refreshToken);
      prevRequest.headers.Authorization = `Bearer ${newAccessToken}`;
      return axiosWebsitePrivate(prevRequest);
    }
    return Promise.reject(error);
  }
);

export default axiosWebsitePrivate;
